import clsx, { type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Tailwind classname combiner: merges conflicting utilities (bg-red-500 vs bg-blue-500 → последний выигрывает).
 * Используется как стандарт в shadcn-style компонентах.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
